// @need-translate
import {useEffect, useRef, useState} from 'react';
import {t} from '../../common/getTranslations';
import {twMerge} from '../../common/twMerge';
import {Text} from '../atoms/Text/Text';
import {Textarea} from '../atoms/Textarea/Textarea';
import {CommentInputFieldProps} from './PcCommentInputFieldProps.interface';

export function PcCommentInputField({
  onClickSend,
  inputBoxClassName,
  ...textareaProps
}: CommentInputFieldProps) {
  const {
    value = '',
    placeholder = t('comment_input'),
    maxLength = 200,
    readOnly,
    className: textareaClassName,
  } = textareaProps;
  const [initialHeightPx, setInitialHeightPx] = useState(0);
  const textareaWrapperRef = useRef<HTMLDivElement>(null);
  // 초기 텍스트가 비어있을 때의 높이값을 잡아둡니다. 줄바꿈이 일어나서 textarea 높이가 변화되면 카운트를 보여줘야 하기 때문에 필요합니다.
  useEffect(() => {
    if (textareaWrapperRef.current) {
      setInitialHeightPx(textareaWrapperRef.current.clientHeight);
    }
  }, []);
  return (
    <div
      className={twMerge(
        'flex w-full items-center px-15pxr',
        inputBoxClassName
      )}
    >
      <div className="flex flex-1 items-center rounded-20pxr border-1 border-solid border-theme-transparent-10 bg-theme-solid-10 py-10pxr px-16pxr">
        <div className="flex flex-1" ref={textareaWrapperRef}>
          <Textarea
            {...textareaProps}
            placeholder={placeholder}
            applyAutoHeight
            maxLength={maxLength}
            value={initialHeightPx ? value : ''}
            className={twMerge('h-18pxr', textareaClassName)}
          />
        </div>
        <Text
          className={twMerge(
            'font-small1 ml-12pxr cursor-pointer text-theme-solid-60',
            (readOnly || !value) && 'cursor-not-allowed text-theme-solid-20'
          )}
          onClick={value && !readOnly ? onClickSend : undefined}
        >
          등록
        </Text>
      </div>
    </div>
  );
}
